import { Portal } from "react-overlays";

import Loadable from "@/mk2/helpers/Loadable";

export const PortalLoadable = Loadable<Portal["props"], any>({
    loader: () =>
        import("react-overlays" /* webpackChunkName: "react-overlays" */).then((module) => {
            return module.Portal;
        }),
    modules: ["react-overlays"],
    webpack: () => [require.resolveWeak("react-overlays")],
});
